import { useAuth } from "../context/AuthContext";
import { baseRoutes, superAdminRoutes } from "./Route";
import Layout from "../Layout/Layout";
import { Route, Routes } from "react-router-dom";

const LayoutRoutes = () => {
  const { user } = useAuth();
  const role = user?.role;
  const finalRoutes =
    role === "SUPER_ADMIN" ? [...baseRoutes, ...superAdminRoutes] : baseRoutes;

  return (
    <Routes>
      {finalRoutes.map(({ path, Component }, i) => (
        <Route element={<Layout />} key={i}>
          <Route path={path} element={Component} />
        </Route>
      ))}
    </Routes>
  );
};

export default LayoutRoutes;
